import { SET_INTRODUCER } from "./action-types";

// action creator : function which returns an action
export const setIntroducer = (introducer) => ({
  type: SET_INTRODUCER,
  payload: { introducer },
});
